import React from 'react';
import { graphql } from 'gatsby';
import { RecommendProducts } from '@sections/shared/GridView';
import { ValuePropsArg } from '@components/ValuePropsSection';
import { ExternalBrandPage } from '@sections/shared/ExternalBrandPage';
import { useTranslation } from 'react-i18next';

const page = 'amazon-registry';

interface AmazonBlissRegistryData {
  recommendCatalogHomeSections: {
    sections: {
      paginatedCatalogEntities: {
        edges: RecommendProducts;
      };
    }[];
  };
}

interface AmazonRegistryPageData {
  bliss: AmazonBlissRegistryData;
}

export const query = graphql`
  {
    bliss {
      recommendCatalogHomeSections {
        sections(offset: 1, limit: 1) {
          paginatedCatalogEntities(first: 8) {
            edges {
              node {
                ... on Bliss_ProductCatalogEntityItemGroup {
                  catalogItemGroupData {
                    tileViewItem {
                      id
                      title
                      brand {
                        name
                        publicUrlPath
                      }
                      publicUrlPath
                      photos {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
const imageData = {
  heroImage: 'seo-external-registries/amazon/desktop/hero_v2.jpg',
  heroImageMobile: 'seo-external-registries/amazon/mobile/hero.jpg',
};

const AMAZON_REGISTRY_VALUE_PROPS: ValuePropsArg[] = [
  {
    id: 'freeShipping',
    icon: 'freeShipping',
    title: 'Free Shipping',
  },
  {
    id: 'completionDiscount',
    icon: 'tag',
    title: '20% completion<br />discount',
  },
  {
    id: 'zeroFeeCashFunds',
    icon: 'noFees',
    title: 'Zero-Fee<br />Cash Funds',
  },
  {
    id: 'easyReturns',
    icon: 'easyReturns',
    title: 'Easy<br />Returns',
  },
];

const AMAZON_TOP_BRANDS = [
  {
    id: 'Ninja',
    title: 'Ninja',
    image: 'seo-external-registries/amazon/desktop/topbrands_ninja.png',
    link: '/shop/catalog/ninja',
  },
  {
    id: 'Zwilling',
    title: 'Zwilling',
    image: 'seo-external-registries/amazon/desktop/topbrands_zwilling.png',
    link: '/shop/catalog/zwilling',
  },
  {
    id: 'Keurig',
    title: 'Keurig',
    image: 'seo-external-registries/amazon/desktop/topbrands_keuring.png',
    link: '/shop/catalog/keurig',
  },
  {
    id: 'Staub',
    title: 'Staub',
    image: 'seo-external-registries/amazon/desktop/topbrands_staub_v2.png',
    link: '/shop/catalog/staub',
  },
  {
    id: 'iRobot',
    title: 'iRobot',
    image: 'seo-external-registries/amazon/desktop/topbrands_irobot.png',
    link: '/shop/catalog/clothing',
  },
  {
    id: 'Nespresso',
    title: 'Nespresso',
    image: 'seo-external-registries/amazon/desktop/topbrands_nespresso.png',
    link: '/shop/catalog/clothing',
  },
  {
    id: 'Dyson',
    title: 'Dyson',
    image: 'seo-external-registries/amazon/desktop/topbrands_dyson.png',
    link: '/shop/catalog/clothing',
  },
];

const AmazonRegistry = ({ data }: { data: AmazonRegistryPageData }) => {
  const { t } = useTranslation();
  return (
    <ExternalBrandPage
      brandPageData={t('data', { ns: 'amazonRegistry' })}
      page={page}
      idPrefix="AmazonRegistry"
      imageData={imageData}
      valueProps={AMAZON_REGISTRY_VALUE_PROPS}
      departmentsData={AMAZON_TOP_BRANDS}
      products={data.bliss.recommendCatalogHomeSections.sections[0].paginatedCatalogEntities.edges}
      brand="amazon"
      faqQuestions={t('questions.amazonRegistry', { ns: 'faq' })}
    />
  );
};

export default AmazonRegistry;
